var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[_c('div',{staticClass:"icon",on:{"click":_vm.back}},[_c('i',{staticClass:"iconfont icon-arrow-down"})]),_c('h3',{staticClass:"van-ellipsis"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }